
import RcDomainObject from "../../common/RcDomainObject";

export default class Feature extends RcDomainObject {
  
  static MODEL_NAME = "Feature";
      
  static FIELDS = {
    NAME : 'name',
    Price: 'price',
  }
  
  constructor(domain, data) {
    super(domain, data, Feature.MODEL_NAME);
  }

  fields() {
    return Feature.FIELDS;
  }
  
  find() {
    return this.domain.features().findById(this.id());
  }
  
  withName(name) {
    this.put(Feature.FIELDS.NAME, name);
    return this;
  }
  
  name() {
    return this.getString(Feature.FIELDS.NAME);
  }
  
  nameDisplay() {
    if (this.isVehicles()) {
      return "Vehicles";
    }
    if (this.isTimesheets()) {
      return "Hours of Service";
    }
    if (this.isEquipment()) {
      return "Equipment";
    }
    if (this.isInspections()) {
      return "Inspections";
    }
    return this.name();
  }
  
  price() {
    return this.getString(Feature.FIELDS.Price);
  }
  
  isInspections() {
    return this.name() === "com.readychek.feature.inspections";
  }
  
  isTimesheets() {
    return this.name() === "com.readychek.feature.timesheets";
  }
  
  isTrackSleeper() {
    return this.name() === "com.readychek.feature.timesheets.track.sleeper";
  }

  isTrackInspections() {
    return this.name() === "com.readychek.feature.timesheets.track.inspections";
  }

  isTrackCycle() {
    return this.name() === "com.readychek.feature.timesheets.track.cycle";
  }

  isTrackLocation() {
    return this.name() === "com.readychek.feature.timesheets.track.location";
  }

  isTrackDriving() {
    return this.name() === "com.readychek.feature.timesheets.track.driving";
  }

  isVehicles() {
    return this.name() === "com.readychek.feature.vehicles";
  }
  
  isUsers() {
    return this.name() === "com.readychek.feature.users";
  }
  
  isCheckIns() {
    return this.name() === "com.readychek.feature.checkins";
  }
  
  isChecklist() {
    return this.name() === "com.readychek.feature.checklists";
  }
  
  isChecklistsForVehicles() {
    return this.name() === "com.readychek.feature.scheduleoptional";
  }

  isMessages() {
    return this.name() === "com.readychek.feature.messages";
  }
  
  isHome() {
    return this.name() === "com.readychek.feature.home";
  }
  
  isMap() {
    return this.name() === "com.readychek.feature.map";
  }

  isCompliance() {
    return this.name() === "com.readychek.feature.compliance";
  }

  isEquipment() {
    return this.name() === "com.readychek.feature.equipment";
  }

  isEquipmentInspections() {
    return this.name() === "com.readychek.feature.equipment.inspections";
  }

  isGpsDevice() {
    return this.name() === "com.readychek.feature.gps.device";
  }
  
  isFlatRate() {
    return this.name() === "com.readychek.feature.flatrate";
  }

  isSupport() {
    return this.name() === "com.readychek.feature.support";
  }

  isSso() {
    return this.name() === "com.readychek.feature.employmentid";
  }
  
  isOffline() {
    return this.name() === "com.readychek.feature.offline";
  }
  
  isProfileUpdate() {
    return this.name() === "com.readychek.feature.profile.update";
  }
  
  isDivisions() {
    return this.name() === "com.readychek.feature.company.divisions";
  }

  isLabels() {
    return this.name() === "com.readychek.feature.company.labels";
  }

  copy() {
    var data = this._copy();
    return new Feature(this.domain, data);
  }
  
  pointer() {
    var data = {'@rid': this.id()};
    var value = new Feature(this.domain, data);
    return value;
  }
}